import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEOHead from '@/components/feature/SEOHead';
import HeroSection from './components/HeroSection';
import CategoryGrid from './components/CategoryGrid';
import TrendingArticles from './components/TrendingArticles';
import DailyCompetition from './components/DailyCompetition';
import ExclusiveQuote from './components/ExclusiveQuote';
import { siteInfo } from '@/mocks/site';
import AnimatedSection from '@/components/base/AnimatedSection';

export default function Home() {
  return (
    <>
      <SEOHead
        title={`${siteInfo.name} - 最新黑料吃瓜视频_每日大赛_网红反差爆料_明星塌房内幕`}
        description={siteInfo.description}
        keywords={siteInfo.keywords}
        canonical="/"
        schema={[
          {
            '@type': 'Organization',
            name: siteInfo.name,
            url: siteInfo.url,
            description: siteInfo.description,
            logo: {
              '@type': 'ImageObject',
              url: '/vite.svg',
            },
          },
          {
            '@type': 'WebSite',
            name: siteInfo.name,
            url: siteInfo.url,
            description: siteInfo.description,
            inLanguage: 'zh-CN',
            publisher: {
              '@type': 'Organization',
              name: siteInfo.name,
            },
          },
          {
            '@type': 'WebPage',
            name: `${siteInfo.name} - 最新黑料吃瓜视频_每日大赛_网红反差爆料_明星塌房内幕`,
            url: '/',
            description: siteInfo.description,
            inLanguage: 'zh-CN',
          },
        ]}
      />
      <Navbar />
      <main className="w-full">
        <HeroSection />
        <AnimatedSection>
          <CategoryGrid />
        </AnimatedSection>
        <AnimatedSection delay={100}>
          <TrendingArticles />
        </AnimatedSection>
        <AnimatedSection delay={200}>
          <DailyCompetition />
        </AnimatedSection>
        <AnimatedSection delay={300}>
          <ExclusiveQuote />
        </AnimatedSection>
      </main>
      <Footer />
    </>
  );
}